import accessUtils from '../utils/accessUtils';

import { useAuth } from '../components/AuthProvider';
import { useGetListingDetails } from './queries/properties';
import { useOwnershipVerificationState } from './queries/useOwnershipVerification';

import type { PropertyOwnershipVerificationState } from '@zg-rentals/ts-rental-manager-api-client';

type OwnershipVerificationAccess = {
  isEnabled: boolean;
  isLoading: boolean;
  state: PropertyOwnershipVerificationState | undefined;
  shouldShowVerificationStep: boolean;
};

const DISABLED: OwnershipVerificationAccess = {
  isEnabled: false,
  isLoading: false,
  state: undefined,
  shouldShowVerificationStep: false,
};

/** Shared by the wizard and Review so both read one gate. */
export const useOwnershipVerificationAccess = ({
  listingAlias,
}: {
  listingAlias: string;
}): OwnershipVerificationAccess => {
  const { isAuthorized } = useAuth();
  const { data: listingDetails } = useGetListingDetails(listingAlias, { enabled: isAuthorized });

  const isEnabled =
    accessUtils.isOwnershipVerificationRolloutEnabled() &&
    isAuthorized &&
    !listingDetails?.isFeed &&
    !listingDetails?.active &&
    Boolean(listingDetails?.forRentBy);

  const verification = useOwnershipVerificationState({ listingAlias, enabled: isEnabled });

  if (!isEnabled) {
    return DISABLED;
  }

  return {
    isEnabled,
    isLoading: verification.isStateLoading,
    state: verification.state,
    shouldShowVerificationStep: verification.shouldShowVerificationStep,
  };
};
